'use client'

import { useEffect, useRef } from 'react'

import { useRouter } from 'next/navigation'

import { LOGIN_SLUG } from '@/app/constants'
import useGlammaticApi from '@/hooks/use-glammatic-api'
import useStorage from '@/hooks/use-storage'
import { USER_AUTH_STORAGE_KEY } from '@/hooks/use-storage/use-storage.constants'
import { isUserSessionValid } from '@/lib/user/auth'

export default function useUserSessionGuard() {
  const router = useRouter()
  const { logout } = useGlammaticApi()
  const logoutRef = useRef(logout)
  logoutRef.current = logout

  const { value: user, storageLoaded } = useStorage<UserAuth>(USER_AUTH_STORAGE_KEY)
  const sessionValid = isUserSessionValid(user as object)

  useEffect(() => {
    if (!storageLoaded || sessionValid) {
      return
    }

    async function signOutAndRedirect() {
      await logoutRef.current()
      router.replace(LOGIN_SLUG)
    }

    void signOutAndRedirect()
  }, [storageLoaded, sessionValid, router])

  return {
    isLoading: !storageLoaded,
    isRedirecting: storageLoaded && !sessionValid,
    isReady: storageLoaded && sessionValid,
  }
}
